import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleDialogTourConfig: AgTechTourConfig = {
    id: 'sale-dialog-tour',
    name: 'Sale Tour',
    steps: [
        {
            targetId: 'sale-dialog-general',
            title: 'General',
            description: 'Name the sale and set its start and end dates. Task templates and planning tasks are scheduled relative to the start date.',
            position: 'bottom',
        },
        {
            targetId: 'sale-dialog-products',
            skipIfMissing: true,
            title: 'Product Selection',
            description: 'Choose the license to buy for a new sale. The sale is created once payment completes.',
            position: 'top',
        },
    ]
}
